import "../index.js";
import {apps} from "../index";
import type {AdjustPayload} from "./adjustPayload";
import type {FirebasePayload} from "./firebasePayload";
import type { NexusResult, OttoNexus} from "@otto-ec/global-resources/nexus";

export type TrackFirebaseResult =
  | { success: true }
  | { validation_error: Record<string, string> };

export type ThirdpartyTrackingRaw = {
    /**
 *
 */
    trackAdjust(adjustPayload: AdjustPayload): NexusResult<Promise<void>>;

    /**
 *
 */
    trackFirebase(firebasePayload: FirebasePayload): NexusResult<Promise<TrackFirebaseResult>>;
}

export type ThirdpartyTracking = OttoNexus["apps"]["thirdpartyTracking"]

/**
 *
 */
export const thirdpartyTracking: ThirdpartyTracking = apps.thirdpartyTracking;

/**
 *
 */
export const trackAdjust: ThirdpartyTracking["trackAdjust"] = thirdpartyTracking.trackAdjust;

/**
 *
 */
export const trackFirebase: ThirdpartyTracking["trackFirebase"] = thirdpartyTracking.trackFirebase;


